import {
  Button,
  Col,
  Collapse,
  Descriptions,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Tabs,
  Tooltip,
  Typography,
} from "antd";
import printJS from "print-js";
import { useEffect, useRef, useState } from "react";
import cookie from "react-cookies";
import { BiPencil, BiPrinter, BiTransferAlt } from "react-icons/bi";
import {
  toAddOrUpdateArticle,
  toChangeStatusArticle,
  toFiltersArticlesList,
  toGetArticlesList,
  toGetArticlesName,
  toGetCategoryList,
  toGetEmplacementList,
  toGetMarqueList,
  toGetSearchArticlesList,
  toGetStockValue,
} from "./Api";

import {
  EyeInvisibleOutlined,
  EyeOutlined,
  FileTextOutlined,
  PlusOutlined,
  PrinterOutlined,
  RiseOutlined,
} from "@ant-design/icons";
import DataTable from "react-data-table-component";

import Modal from "antd/lib/modal/Modal";
import moment from "moment";
import localization from "moment/locale/fr";
import { DataExistsException } from "../../DataExitsException";
import Article from "../../Models/Article";
import "../../Styles/TwoTables.scss";
import Tecdoc from "../../Utils/Tecdoc";
import {
  errorMsg,
  numberFormatCurrency,
  successMsg,
  toFormatArticleClassifications,
} from "../../Utils/Utils";
import ArticleDetail from "./ArticleDetail";
import ArticleHistory from "./ArticleHistory";
import ArticleModal from "./ArticleModal";
import TecdocLiaison from "./TecdocLiaison";

import { SearchOutlined, AimOutlined } from "@ant-design/icons";
import Loading from "react-loading-bar";
import "react-loading-bar/dist/index.css";
import ArticleFusion from "./ArticleFusion";
import ArticleStat from "./ArticleStat";
import StockTransfert from "./Transfert/StockTransfertModal";
import AdvancedSearchModal from "../../Components/AdvancedSearchModal";
var Barcode = require("react-barcode");

const ls = require("localstorage-ttl");
const { Option } = Select;
const { Panel } = Collapse;
moment.updateLocale("fr", localization);

const Articles = () => {
  const [form] = Form.useForm();
  const [marques, setMarques] = useState([]);
  const [articleHistory, setArticleHistory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [searchModalVisible, setSearchModalVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [tecdocModalVisible, setTecdocModalVisible] = useState(false);
  const [fusionVisible, setFusionVisible] = useState(false);
  const [detailVisble, setDetailVisible] = useState(false);
  const [tecdocLiaison, setTecdocLiaison] = useState(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [article, setArticle] = useState("");
  const [categories, setCategories] = useState([]);
  const [emplacements, setEmplacements] = useState([]);
  const [transfertModal, setTransfertModal] = useState(false);
  const [articleDetails, setArticleDetails] = useState({
    title: "",
    reference: "",
    marque: "",
    type: "Origine",
    categorie: "",
  });
  const [articleDisplay, setArticleDisplay] = useState("");
  const [articles, setArticles] = useState([]);
  const [articlesArchivated, setArticlesArchivated] = useState([]);
  const [articlesAll, setArticlesAll] = useState([]);
  const [articlesNames, setArticleNames] = useState([]);
  const [show, setShow] = useState(true);
  const [activeKey, setActiveKey] = useState(-1);
  const [selectedArticles, setSelectedArticles] = useState([]);
  const [articleBarCode, setArticleBarCode] = useState(null);
  const [data, setData] = useState(null);
  const [emplacementMode, setEmplacementMode] = useState("simple");
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [printChoiceVisible, setPrintChoiceVisible] = useState(false);
  const printPendingData = useRef([]);
  useEffect(() => {
    toGetDatas(0);
    form.setFieldsValue({
      categorie: "0",
      emplacement: "0",
      emplacementMode: "simple",
      emplacements: [],
      emplacementFrom: "",
      emplacementTo: "",
      emplacementPrefix: "",
      marque: "0",
      searchAvancée: "",
      searchWord: "Tout",
      tecdoc: "0",
      type: "0",
      stock: "Tout",
      stockValue: "0",
    });
  }, []);

  const callback = (key) => {
    setActiveKey(key);
  };
  const toGetDatas = () => {
    toGetMarqueList().then((res) => {
      setMarques(res);
    });
    toGetCategoryList().then((res) => {
      setCategories(res);
      console.log(res.filter((el) => el.title == "AMORT"));
    });
    toGetEmplacementList().then((res) => {
      setEmplacements(res);
    });
    setLoading(true);
    if (ls.get(`articles`) != null) {
      setArticles(ls.get(`articles`));
      setArticlesAll(ls.get(`articles`));
      setLoading(false);
    }
    toGetArticlesList(0, 1).then((res) => {
      setArticles(res);
      setArticlesAll(res);
      setTotalCount(res.length);
      setLoading(false);
    });
    toGetArticlesList(0, 0).then((res) => {
      setArticlesArchivated(res);
    });

    if (null != ls.get("articles_name")) {
      setArticleNames(ls.get("articles_name"));
    }
    toGetArticlesName().then((res) => {
      setArticleNames(res);
    });
    setShow(false);
  };

  const afterBind = () => {
    if (searchValue != "") {
      setTecdocLiaison(false);

      onSearch(searchValue);
      setLoading(false);
    } else {
      setTecdocLiaison(false);

      toSearch();
    }
  };

  const onSearch = (value, ref) => {
    if (ref) {
      form.setFieldsValue({ searchWord: "" });
    } else {
      form.setFieldsValue({ searchAvancée: "" });
    }
    setSearchValue(value);
    if (value.length == 1) {
      errorMsg("Veuillez entrer 2 caractères merci!");
    } else {
      setLoading(true);
      toGetArticles(value, ref);
    }
  };

  const toGetArticles = async (search, ref) => {
    if (search == "") {
      //todo change this in react
      toGetArticlesList(0, 0).then((data) => {
        setPage(0);
        setArticles(data);
        setArticlesAll(data);

        setLoading(false);
      });
    } else {
      toGetSearchArticlesList(search).then((res) => {
        setArticles(res);
        setArticlesAll(res);
        setLoading(false);
      });
    }

    toGetArticlesList(0, 1).then((data) => {
      setArticlesArchivated(data);

      setLoading(false);
    });
  };

  const saveArticle = async (id, article, automaticCode) => {
    try {
      var newArticle = await toAddOrUpdateArticle(id, article, automaticCode);

      if (id == -1) {
        setArticles([...articles, newArticle]);
        successMsg("Article créé avec succés");
      } else {
        const articleIndex = articles.findIndex((c) => c.id == id);
        const newArticles = [...articles];
        newArticles[articleIndex] = {
          ...articles[articleIndex],
          ...newArticle,
        };
        setArticles(newArticles);
        successMsg("Article modifié avec succés");
      }
      setCreateModalVisible(false);
    } catch (e) {
      if (e instanceof DataExistsException) {
        errorMsg("L'article existe déja");
      } else {
        errorMsg("Une erreur est survenue");
      }
    }
  };

  const toEdit = (article) => {
    setArticleDetails({
      ...article,
      id: article.id,
      titre: article.s__firstTitle,
      titre2: article.s__secondTitle,
      reference: article.s__reference,
      code: article.s__barCode,
      type: article.s__type,
      unite: article.unite,
      marque: article.marqueTitle,
      categorie: article.categoryTitle,
      emplacement: null != article.emplacement ? article.emplacement.title : "",
      seuil: article.l__seuil,
      tva: article.tva,
      prixAchatHT: article.l__prixAchatHT,
      prixAchatTTC: article.l__prixAchatTTC,
      data: article.data,
      b__tecdoc: article.b__tecdoc,
      marge: article.l__marge,
      margeValue: article.l__margeValue,
      prixVenteHT: article.l__prixVenteHT,
      prixVenteTTC: article.l__prixVenteTTC,
      free: article.free,

      margeGros: article.l__margeGros,
      margeGrosValue: article.l__margeGrosValue,
      prixVenteGrosHT: article.l__prixVenteGrosHT,
      prixVenteGrosTTC: article.l__prixVenteGrosTTC,
    });
    setCreateModalVisible(true);
  };

  const toDisplayArticle = (article) => {
    setArticleDisplay({
      ...article,
      id: article.id,
      titre: article.s__firstTitle,
      titre2: article.s__secondTitle,
      reference: article.s__reference,
      code: article.s__barCode,
      type: article.s__type,
      unite: article.unite,
      marque: article.marqueTitle,
      categorie: article.categoryTitle,
      emplacement: article.emplacement,
      seuil: article.l__seuil,
      tva: article.tva,
      prixAchatHT: article.l__prixAchatHT,
      prixAchatTTC: article.l__prixAchatTTC,
      data: article.data,
      b__tecdoc: article.b__tecdoc,
      marge: article.l__marge,
      margeValue: article.l__margeValue,
      prixVenteHT: article.l__prixVenteHT,
      prixVenteTTC: article.l__prixVenteTTC,

      margeGros: article.l__margeGros,
      margeGrosValue: article.l__margeGrosValue,
      prixVenteGrosHT: article.l__prixVenteGrosHT,
      prixVenteGrosTTC: article.l__prixVenteGrosTTC,
    });
    setDetailVisible(true);
  };
  const toAdd = () => {
    setArticleDetails(new Article());
    setCreateModalVisible(true);
  };
  const exitCreateModal = () => {
    setCreateModalVisible(false);
  };

  const addFromTecdoc = async (article) => {
    var a = new Article();
    a.titre = article.articleProductName;
    a.titre2 = article.articleProductName;
    a.img = article.s3image;
    a.reference = article.articleNo;
    a.marque = article.supplierName;
    a.type = "Adaptable";
    a.categorie = article.fullName;
    a.data = toFormatArticleClassifications(article);
    a.referenceTecdoc = article.articleNo;
    a.fromTecdoc = true;
    a.code = article.code;

    setArticleDetails(a);

    setCreateModalVisible(true);
  };

  const exitModalTecdoc = () => {
    setTecdocModalVisible(false);
  };

  const toSearch = (pageNum, perPageNum) => {
    setSelectedArticles([]);
    setActiveKey(-1);
    const currentPage = pageNum === undefined ? 0 : pageNum;
    const currentPerPage = perPageNum ?? perPage;
    toGetStockValue(form.getFieldsValue(), currentPage).then((res) => {
      setData(res);
    });
    setShow(true);
    const empMode = form.getFieldValue("emplacementMode") || "simple";
    const isEmpDefault =
      (empMode === "simple" && form.getFieldValue("emplacement") == "0") ||
      (empMode === "multiple" &&
        (!form.getFieldValue("emplacements") ||
          form.getFieldValue("emplacements").length === 0)) ||
      (empMode === "range" &&
        form.getFieldValue("emplacementFrom") === "" &&
        form.getFieldValue("emplacementTo") === "") ||
      (empMode === "prefix" && form.getFieldValue("emplacementPrefix") === "");
    if (
      form.getFieldValue("categorie") == "0" &&
      isEmpDefault &&
      form.getFieldValue("marque") == "0" &&
      form.getFieldValue("tecdoc") == "0" &&
      form.getFieldValue("type") == "0" &&
      form.getFieldValue("stock") == "Tout" &&
      form.getFieldValue("searchWord") == "Tout" &&
      form.getFieldValue("searchAvancée") == ""
    ) {
      toGetArticlesList(0).then((res) => {
        setArticles(res);
        setArticlesAll(res);
        setTotalCount(res.length);
        setPage(0);
        setLoading(false);
        setShow(false);
      });
      return;
    }

    toFiltersArticlesList(
      form.getFieldsValue(),
      currentPage,
      currentPerPage,
    ).then((res) => {
      const list = res.articles ?? [];
      setArticles(list);
      setArticlesAll(list);
      setTotalCount(res.total ?? 0);
      setPage(currentPage);
      setLoading(false);
      setShow(false);
    });
  };

  const handlePageChange = (newPage) => {
    toSearch(newPage - 1, perPage);
  };

  const handlePerPageChange = (newPerPage, newPage) => {
    setPerPage(newPerPage);
    toSearch(0, newPerPage);
  };

  const toChangeStatus = (id, actif) => {
    toChangeStatusArticle(id, !actif).then((res) => {
      const all = [...articles];
      if (actif) {
        setArticlesArchivated({
          ...all.filter((el) => el.id !== id)[0],
          articlesArchivated,
        });

        setArticles(all.filter((el) => el.id !== id));
      } else {
        setArticle({
          ...articlesArchivated.filter((el) => el.id !== id)[0],
          all,
        });

        setArticlesArchivated(articlesArchivated.filter((el) => el.id !== id));
      }
    });
  };

  const conditionalRowStyles = [
    {
      when: (row) => moment(row.dtVente).diff(moment() + 1) > 30,
      style: {
        backgroundColor: "yellow",
        color: "white",
      },
      when: (row) => moment(row.dtVente).diff(moment() + 1) > 90,
      style: {
        backgroundColor: "orange",
        color: "white",
      },
      when: (row) => moment(row.dtVente).diff(moment() + 1) > 180,
      style: {
        backgroundColor: "red",
        color: "white",
      },
    },
  ];
  const columns = [
    {
      name: "TD",
      selector: "b__tecdoc",

      format: (article) => (
        <img
          onClick={() => {
            setArticle(article);
            setTecdocLiaison(true);
          }}
          src="/images/tecdoc.png"
          className={
            article.b__tecdoc ? "auto-tecdoc-img" : "auto-tecdoc-img-gray"
          }
          alt="smtv-logo"
        />
      ),
      grow: 0.15,
    },
    {
      name: "Titre",
      selector: "s__secondTitle",
      grow: 2,
    },
    {
      name: "Référence",
      selector: "s__reference",
    },
    {
      name: "Marque",
      selector: "marqueTitle",
    },
    {
      name: "Catégorie",
      selector: "categoryTitle",
      sortable: true,
    },
    {
      name: "Date dernière vente",
      selector: "dtVente",
    },
    {
      name: "Date dernier achat",
      selector: "dtAchat",
    },
    {
      name: "Prix de vente TTC",
      selector: "displayableName",
      sortable: true,
      format: (article) => `${article.l__prixVenteTTC.toFixed(3)} DT`,
    },

    {
      name: "Stock",
      selector: "stock",
      format: (article) => <>{getEmplacementStock(article)}</>,
      grow: 1.25,
    },
    {
      name: "Actions",
      selector: "stock",
      grow: 2.5,
      format: (article) => (
        <>
          <Button
            type="link"
            size="large"
            icon={<FileTextOutlined />}
            onClick={(e) => toDisplayArticle(article)}
          ></Button>
          <Button
            type="link"
            size="large"
            icon={<BiTransferAlt />}
            onClick={(e) => {
              setArticleDisplay({
                id: article.id,
                titre: article.s__firstTitle,
                titre2: article.s__secondTitle,
                reference: article.s__reference,
                code: article.s__barCode,
                type: article.s__type,
                unite: article.unite,
                marque: article.marqueTitle,
                categorie: article.categoryTitle,
                emplacement: article.emplacement,
                seuil: article.l__seuil,
                tva: article.tva,
                prixAchatHT: article.l__prixAchatHT,
                prixAchatTTC: article.l__prixAchatTTC,
                data: article.data,
                b__tecdoc: article.b__tecdoc,
                marge: article.l__marge,
                margeValue: article.l__margeValue,
                prixVenteHT: article.l__prixVenteHT,
                prixVenteTTC: article.l__prixVenteTTC,

                margeGros: article.l__margeGros,
                margeGrosValue: article.l__margeGrosValue,
                prixVenteGrosHT: article.l__prixVenteGrosHT,
                prixVenteGrosTTC: article.l__prixVenteGrosTTC,
              });

              setTransfertModal(true);
            }}
          ></Button>
          <Button
            type="link"
            size="large"
            icon={<RiseOutlined />}
            onClick={(e) =>
              setArticleHistory({
                id: article.id,
                titre: article.s__firstTitle,
                titre2: article.s__secondTitle,
                reference: article.s__reference,
                code: article.s__barCode,
                type: article.s__type,
                unite: article.unite,
                marque: article.marqueTitle,
                categorie: article.categoryTitle,
                emplacement:
                  null != article.emplacement ? article.emplacement.title : "",
                seuil: article.l__seuil,
                tva: article.tva,
                prixAchatHT: article.l__prixAchatHT,
                prixAchatTTC: article.l__prixAchatTTC,
                data: article.data,
                b__tecdoc: article.b__tecdoc,
                marge: article.l__marge,
                margeValue: article.l__margeValue,
                prixVenteHT: article.l__prixVenteHT,
                prixVenteTTC: article.l__prixVenteTTC,

                margeGros: article.l__margeGros,
                margeGrosValue: article.l__margeGrosValue,
                prixVenteGrosHT: article.l__prixVenteGrosHT,
                prixVenteGrosTTC: article.l__prixVenteGrosTTC,
              })
            }
          ></Button>
          <Button
            type="link"
            icon={<BiPencil />}
            onClick={(e) => toEdit(article)}
          />

          <Tooltip title="Pour imprimer le code à barre">
            <Button
              type="link"
              icon={<BiPrinter />}
              onClick={(e) => toOpenModal(article)}
            />
          </Tooltip>
          {cookie.load("role") == "Super Admin" && (
            <Tooltip
              title={`Pour ${
                article.b__active ? "archiver" : "reactiver"
              } l'article`}
            >
              <Button
                type="link"
                icon={
                  article.b__active ? <EyeInvisibleOutlined /> : <EyeOutlined />
                }
                onClick={(e) => toChangeStatus(article.id, article.b__active)}
              />
            </Tooltip>
          )}
        </>
      ),
    },
  ];
  const getEmplacementStock = (article) => {
    const mode = form.getFieldValue("emplacementMode") || "simple";
    const emp = form.getFieldValue("emplacement");
    const emps = form.getFieldValue("emplacements") || [];
    const fromVal = form.getFieldValue("emplacementFrom") || "";
    const toVal = form.getFieldValue("emplacementTo") || "";
    const prefixVal = form.getFieldValue("emplacementPrefix") || "";

    const isActive =
      (mode === "simple" && emp !== "0") ||
      (mode === "multiple" && emps.length > 0) ||
      (mode === "range" && fromVal !== "" && toVal !== "") ||
      (mode === "prefix" && prefixVal !== "");

    if (isActive) {
      var stock = 0;
      var empCount = 0;
      if (Array.isArray(article?.emplacement)) {
        if (mode === "simple") {
          article?.emplacement.forEach((e) => {
            if (e.emp == emp) {
              stock = e.stock;
              empCount++;
            }
          });
        } else if (mode === "multiple") {
          article?.emplacement.forEach((e) => {
            if (emps.includes(e.emp)) {
              stock += Number(e.stock);
              empCount++;
            }
          });
        } else if (mode === "range") {
          const prefix = fromVal.replace(/[0-9]/g, "");
          const fromNum = parseInt(fromVal.replace(prefix, "")) || 0;
          const toNum = parseInt(toVal.replace(prefix, "")) || 0;
          article?.emplacement.forEach((e) => {
            const num = parseInt(e.emp.replace(prefix, ""));
            if (e.emp.startsWith(prefix) && num >= fromNum && num <= toNum) {
              stock += Number(e.stock);
              empCount++;
            }
          });
        } else if (mode === "prefix") {
          article?.emplacement.forEach((e) => {
            if (e.emp.startsWith(prefixVal)) {
              stock += Number(e.stock);
              empCount++;
            }
          });
        }
      }

      return (
        <>
          <p>Total Emp: {stock}</p>
          {empCount > 1 && (
            <small style={{ color: "#888" }}>({empCount} emp.)</small>
          )}
          <span
            className={
              article.stock <= 0
                ? "auto--color-danger"
                : article.stock < article.l__seuil
                ? "auto--color-warning"
                : "auto--color-success"
            }
          >
            Total : {article.stock}
          </span>
        </>
      );
    }
    return (
      <>
        <span
          className={
            article.stock <= 0
              ? "auto--color-danger"
              : article.stock < article.l__seuil
              ? "auto--color-warning"
              : "auto--color-success"
          }
        >
          Total: {article.stock}
        </span>
        {Array.isArray(article?.emplacement) &&
          article?.emplacement.map((e) => (
            <div key={e.emp} style={{ marginBottom: "5px" }}>
              {e.stock + " => " + e.emp}
            </div>
          ))}
      </>
    );
  };
  const toOpenModal = (article) => {
    setArticleBarCode(article);
    setOpen(true);
  };

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "1rem",
      },
    },
  };

  const onSelectRow = (e) => {
    setSelectedArticles(e.selectedRows);
  };

  const getEmpDisplay = (element) => {
    if (
      !Array.isArray(element?.emplacement) ||
      element.emplacement.length === 0
    )
      return "-";
    return element.emplacement
      .map((e) => e.emp + "(" + e.stock + ")")
      .join(", ");
  };

  const getJsonToPrint = (data) => {
    var items = data ?? selectedArticles;
    var res = [];
    items.forEach((element) => {
      const mode = form.getFieldValue("emplacementMode") || "simple";
      const emp = form.getFieldValue("emplacement");
      const emps = form.getFieldValue("emplacements") || [];
      const fromVal = form.getFieldValue("emplacementFrom") || "";
      const toVal = form.getFieldValue("emplacementTo") || "";
      const prefixVal = form.getFieldValue("emplacementPrefix") || "";

      var stock = element.stock;
      const isActive =
        (mode === "simple" && emp !== "0") ||
        (mode === "multiple" && emps.length > 0) ||
        (mode === "range" && fromVal !== "" && toVal !== "") ||
        (mode === "prefix" && prefixVal !== "");

      if (isActive) {
        stock = 0;
        if (Array.isArray(element?.emplacement)) {
          if (mode === "simple") {
            element?.emplacement.forEach((e) => {
              if (e.emp == emp) stock = e.stock;
            });
          } else if (mode === "multiple") {
            element?.emplacement.forEach((e) => {
              if (emps.includes(e.emp)) stock += Number(e.stock);
            });
          } else if (mode === "range") {
            const prefix = fromVal.replace(/[0-9]/g, "");
            const fromNum = parseInt(fromVal.replace(prefix, "")) || 0;
            const toNum = parseInt(toVal.replace(prefix, "")) || 0;
            element?.emplacement.forEach((e) => {
              const num = parseInt(e.emp.replace(prefix, ""));
              if (e.emp.startsWith(prefix) && num >= fromNum && num <= toNum)
                stock += Number(e.stock);
            });
          } else if (mode === "prefix") {
            element?.emplacement.forEach((e) => {
              if (e.emp.startsWith(prefixVal)) stock += Number(e.stock);
            });
          }
        }
      }
      res.push({
        titre: element.s__secondTitle,
        référence: element.s__reference,
        marque: element.marqueTitle,
        emplacement: getEmpDisplay(element),
        qte: stock,
        prix: element.l__prixVenteTTC.toFixed(3),
      });
    });
    return res;
  };

  const getHeader = () => {
    var result = "";
    if (form.getFieldValue("searchWord") != "Tout") {
      result += "-Désignation: " + form.getFieldValue("searchWord");
    }
    if (form.getFieldValue("searchAvancée") != "") {
      result += " -Référence: " + form.getFieldValue("searchAvancée");
    }
    const empMode = form.getFieldValue("emplacementMode") || "simple";
    const emp = form.getFieldValue("emplacement");
    const emps = form.getFieldValue("emplacements") || [];
    const fromVal = form.getFieldValue("emplacementFrom") || "";
    const toVal = form.getFieldValue("emplacementTo") || "";
    const prefixVal = form.getFieldValue("emplacementPrefix") || "";
    if (empMode === "simple" && emp != "0") {
      result += " -Emplacement: " + emp;
    } else if (empMode === "multiple" && emps.length > 0) {
      result += " -Emplacements: " + emps.join(", ");
    } else if (empMode === "range" && fromVal && toVal) {
      result += " -Emp: " + fromVal + "→" + toVal;
    } else if (empMode === "prefix" && prefixVal) {
      result += " -Emp: " + prefixVal + "*";
    }
    if (form.getFieldValue("categorie") != "0") {
      result += " -Catégorie: " + form.getFieldValue("categorie");
    }
    if (form.getFieldValue("marque") != "0") {
      result += " -Marque: " + form.getFieldValue("marque");
    }
    if (form.getFieldValue("tecdoc") != "0") {
      result += " -Tecdoc: " + form.getFieldValue("tecdoc");
    }
    if (form.getFieldValue("type") != "0") {
      result += " -Type: " + form.getFieldValue("type");
    }
    if (form.getFieldValue("stock") != "Tout") {
      result +=
        " -Stock: " +
        form.getFieldValue("stock") +
        " " +
        form.getFieldValue("stockValue");
    }
    return result;
  };

  const executePrint = (type) => {
    const items = printPendingData.current;
    const jsonData = items.map((element) => {
      const mode = form.getFieldValue("emplacementMode") || "simple";
      const emp = form.getFieldValue("emplacement");
      const emps = form.getFieldValue("emplacements") || [];
      const fromVal = form.getFieldValue("emplacementFrom") || "";
      const toVal = form.getFieldValue("emplacementTo") || "";
      const prefixVal = form.getFieldValue("emplacementPrefix") || "";

      var stock = element.stock;
      const isActive =
        (mode === "simple" && emp !== "0") ||
        (mode === "multiple" && emps.length > 0) ||
        (mode === "range" && fromVal !== "" && toVal !== "") ||
        (mode === "prefix" && prefixVal !== "");

      if (isActive) {
        stock = 0;
        if (Array.isArray(element?.emplacement)) {
          if (mode === "simple") {
            element?.emplacement.forEach((e) => {
              if (e.emp == emp) stock = e.stock;
            });
          } else if (mode === "multiple") {
            element?.emplacement.forEach((e) => {
              if (emps.includes(e.emp)) stock += Number(e.stock);
            });
          } else if (mode === "range") {
            const prefix = fromVal.replace(/[0-9]/g, "");
            const fromNum = parseInt(fromVal.replace(prefix, "")) || 0;
            const toNum = parseInt(toVal.replace(prefix, "")) || 0;
            element?.emplacement.forEach((e) => {
              const num = parseInt(e.emp.replace(prefix, ""));
              if (
                e.emp.startsWith(prefix) &&
                num >= fromNum &&
                num <= toNum
              )
                stock += Number(e.stock);
            });
          } else if (mode === "prefix") {
            element?.emplacement.forEach((e) => {
              if (e.emp.startsWith(prefixVal)) stock += Number(e.stock);
            });
          }
        }
      }

      if (type === "prix") {
        return {
          référence: element.s__reference,
          désignation: element.s__secondTitle,
          prix_ttc: element.l__prixVenteTTC.toFixed(3),
          marque: element.marqueTitle,
        };
      }

      var filteredEmps = element?.emplacement;
      if (isActive && Array.isArray(element?.emplacement)) {
        if (mode === "simple") {
          filteredEmps = element.emplacement.filter((e) => e.emp == emp);
        } else if (mode === "multiple") {
          filteredEmps = element.emplacement.filter((e) => emps.includes(e.emp));
        } else if (mode === "range") {
          const prefix = fromVal.replace(/[0-9]/g, "");
          const fromNum = parseInt(fromVal.replace(prefix, "")) || 0;
          const toNum = parseInt(toVal.replace(prefix, "")) || 0;
          filteredEmps = element.emplacement.filter((e) => {
            const num = parseInt(e.emp.replace(prefix, ""));
            return e.emp.startsWith(prefix) && num >= fromNum && num <= toNum;
          });
        } else if (mode === "prefix") {
          filteredEmps = element.emplacement.filter((e) =>
            e.emp.startsWith(prefixVal)
          );
        }
      }

      const empDisplay =
        !Array.isArray(filteredEmps) || filteredEmps.length === 0
          ? "-"
          : filteredEmps.map((e) => e.emp + "(" + e.stock + ")").join(", ");

      return {
        référence: element.s__reference,
        désignation: element.s__secondTitle,
        emplacement: empDisplay,
        qte: stock,
      };
    });

    const properties =
      type === "prix"
        ? ["référence", "désignation", "prix_ttc", "marque"]
        : ["référence", "désignation", "emplacement", "qte"];

    const title =
      type === "prix"
        ? "<h2 style='text-align:center;margin-bottom:10px'>Liste des prix</h2>"
        : "<h2 style='text-align:center;margin-bottom:10px'>Inventaire</h2>";

    printJS({
      style: "body { margin: 0; font-size: 12px; }",
      printable: jsonData,
      properties: properties,
      type: "json",
      header: title + "<h4>" + getHeader() + "</h4>",
    });

    setPrintChoiceVisible(false);
  };

  const toPrint = () => {
    var container = document.getElementById("to-print");
    var mySVG = document.getElementById("barcode-canvas");
    var width = "100%";
    var height = "100%";
    var printWindow = window.open("", "PrintMap", "width=800,height=500");
    printWindow.document.writeln(container.innerHTML);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    setOpen(false);
    setArticleBarCode(null);
  };

  return (
    <div id="achat">
      {null != articleBarCode && (
        <Modal
          title={""}
          visible={open}
          onCancel={() => {
            setOpen(false);
            setArticleBarCode(null);
          }}
          footer={[<Button onClick={() => toPrint()}>Imprimer</Button>]}
        >
          <div id="to-print" style={{ textAlign: "center" }}>
            <p>
              <b>{articleBarCode.s__secondTitle}</b>
            </p>
            <p style={{ fontWeight: "bold" }}>
              {"Réf: " + articleBarCode.s__reference}
            </p>
            <Barcode value={articleBarCode.s__barCode} />,
          </div>
        </Modal>
      )}
      <Loading show={show} color="red" showSpinner={true} />

      <Form>
        <Row gutter="12" className="auto--custom-header">
          <Col span="12">
            <Typography.Title level={3}>Articles</Typography.Title>
          </Col>

          <Col span="12" style={{ textAlign: "right" }}>
            <Button
              icon={<PlusOutlined />}
              onClick={(e) => toAdd()}
              type="primary"
            >
              Ajouter un article
            </Button>

            <Button
              icon={<PlusOutlined />}
              style={{ marginLeft: "1vh" }}
              onClick={(e) => setTecdocModalVisible(true)}
              type="primary"
            >
              Ajouter un article via Tecdoc
            </Button>
            <Button
              style={{ marginLeft: "1vh" }}
              onClick={(e) => setFusionVisible(true)}
              type="primary"
            >
              Fusionner article
            </Button>
            {/* <Button onClick={(e) => toAdd()} type="primary">
              Stats article
            </Button> */}
          </Col>
        </Row>
      </Form>

      <Form
        form={form}
        layout="vertical"
        //onValuesChange={(e) => onValuesChange(e)}
      >
        <Row gutter="6" className="auto--custom-header">
          <Col md={4}>
            <Form.Item
              label="Désignation"
              style={{ marginBottom: 0 }}
              name="searchWord"
            >
              <Select
                showSearch
                placeholder="Recherche par désignation..."
                optionFilterProp="children"
                defaultValue="Tout"
              >
                <Option value="Tout">Tout</Option>

                {articlesNames.map((name) => (
                  <Option value={name}>{name}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span="4">
            <Form.Item
              label="Référence, titre, code à barre"
              name="searchAvancée"
            >
              <Input.Search
                label="Référence, titre, code à barre"
                enterButton
              />
            </Form.Item>
          </Col>
          <Col span="2">
            <Form.Item name="tecdoc" label="Tecdoc">
              <Select defaultValue="0" optionFilterProp="children">
                <Option value="0">Tout</Option>
                <Option value="1">Liée avec tecdoc</Option>
                <Option value="2">Non liée avec tecdoc</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span="2">
            <Form.Item label="Type" name="type">
              <Select showSearch defaultValue="0">
                <Select.Option value="0">Tout</Select.Option>
                <Select.Option value="Origine">Origine</Select.Option>
                <Select.Option value="Adaptable">Adaptable</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item label="Marque" name="marque">
              <Select showSearch style={{ width: "100%" }} defaultValue="0">
                <Option value="0">Tout</Option>
                {marques.map((marque, i) => (
                  <Option value={marque.title} key={i}>
                    {marque.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item label="Catégorie" name="categorie">
              <Select
                showSearch
                style={{ width: "100%" }}
                defaultValue="0"
                filterOption={(input, option) =>
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option value="0" key={99999999}>
                  Tout
                </Option>
                {categories.map((c, i) => (
                  <Option value={c.title} key={i}>
                    {c.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Emplacement">
              <Input.Group compact>
                <Form.Item name="emplacementMode" noStyle>
                  <Select
                    style={{ width: "28%" }}
                    defaultValue="simple"
                    onChange={(val) => setEmplacementMode(val)}
                  >
                    <Option value="simple">Simple</Option>
                    <Option value="multiple">Multi</Option>
                  </Select>
                </Form.Item>
                {emplacementMode === "simple" && (
                  <Form.Item name="emplacement" noStyle>
                    <Select
                      showSearch
                      style={{ width: "72%" }}
                      defaultValue="0"
                      filterOption={(input, option) =>
                        option?.value
                          ?.toString()
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      <Option value="0" key={99999999}>
                        Tout
                      </Option>
                      {emplacements.map((e, i) => (
                        <Option value={e.title} key={i}>
                          {e.title}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
                {emplacementMode === "multiple" && (
                  <Form.Item name="emplacements" noStyle>
                    <Select
                      mode="multiple"
                      showSearch
                      style={{ width: "72%" }}
                      placeholder="Sélectionner..."
                      filterOption={(input, option) =>
                        option?.children
                          ?.toString()
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {emplacements.map((e, i) => (
                        <Option value={e.title} key={i}>
                          {e.title}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
                {emplacementMode === "range" && (
                  <>
                    <Form.Item name="emplacementFrom" noStyle>
                      <Input style={{ width: "36%" }} placeholder="De (A1)" />
                    </Form.Item>
                    <span
                      style={{
                        display: "inline-block",
                        width: "4%",
                        textAlign: "center",
                      }}
                    >
                      →
                    </span>
                    <Form.Item name="emplacementTo" noStyle>
                      <Input style={{ width: "32%" }} placeholder="À (A120)" />
                    </Form.Item>
                  </>
                )}
                {emplacementMode === "prefix" && (
                  <Form.Item name="emplacementPrefix" noStyle>
                    <Input
                      style={{ width: "72%" }}
                      placeholder="Ex: A pour tout les A*"
                    />
                  </Form.Item>
                )}
              </Input.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter="6" className="auto--custom-header">
          <Col span="2">
            <Form.Item label="Stock" name="stock">
              <Select defaultValue="Tout">
                <Option value="Tout">Tout</Option>

                <Option value="=">Egal</Option>

                <Option value=">">Supérieur</Option>
                <Option value="<">Inférieur</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span="2">
            <Form.Item name="stockValue">
              <InputNumber min={0} defaultValue={0} />
            </Form.Item>
          </Col>
          {/* <Col span="3">
                <Form.Item label="Date de création" name="date">
                  <Select>
                    <Option value="aujourdhui">Aujourd'hui</Option>
                    <Option value="hier">Hier</Option>
                    <Option value="cemois">Ce mois</Option>
                  </Select>
                </Form.Item>
              </Col> */}

          <Col span="3">
            <Form.Item>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => toSearch()}
              >
                Chercher
              </Button>
            </Form.Item>
          </Col>
          <Col span="3">
            <Form.Item>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setSearchModalVisible(true)}
              >
                Recherche avancée
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Row
        style={{
          overflowY: "hidden",
          marginTop: "2vh",
        }}
      >
        <Col span="23">
          <Tabs>
            <Tabs.TabPane key="1" tab="Articles">
              <DataTable
                customStyles={customStyles}
                columns={columns}
                data={articles}
                pagination
                paginationServer
                paginationTotalRows={totalCount}
                paginationDefaultPage={page + 1}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerPageChange}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[25, 50, 100, 200]}
                selectableRows
                noHeader
                striped
                selectableRowsHighlight
                fixedHeader
                onSelectedRowsChange={(e) => onSelectRow(e)}
                persistTableHead
                noDataComponent={<span>Pas d'articles trouvés</span>}
                contextMessage={{
                  singular: "élément",
                  plural: "éléments",
                  message: "séléctionné(s)",
                }}
                conditionalRowStyles={conditionalRowStyles}
              />{" "}
              {cookie.load("role") == "Super Admin" && null != data && (
                <Descriptions
                  bordered
                  style={{ backgroundColor: "white", marginTop: "3px" }}
                >
                  <Descriptions.Item label="Quantité" className="item-label">
                    {data.qte}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label="Valeur Stock"
                    className="item-label"
                  >
                    {numberFormatCurrency(data.value)}
                  </Descriptions.Item>
                </Descriptions>
              )}
              {selectedArticles.length > 0 && (
                <Button
                  type="primary"
                  icon={<PrinterOutlined />}
                  onClick={() => {
                    printPendingData.current = selectedArticles;
                    setPrintChoiceVisible(true);
                  }}
                >
                  Imprimer sélection
                </Button>
              )}
              {articles.length > 0 && (
                <Button
                  type="default"
                  icon={<PrinterOutlined />}
                  loading={loadingPrint}
                  style={{ marginLeft: "1vh" }}
                  onClick={() => {
                    setLoadingPrint(true);
                    toFiltersArticlesList(form.getFieldsValue(), 0, totalCount)
                      .then((res) => {
                        const all = res.articles ?? [];
                        printPendingData.current = all;
                        setPrintChoiceVisible(true);
                      })
                      .finally(() => setLoadingPrint(false));
                  }}
                >
                  Tout imprimer
                </Button>
              )}
            </Tabs.TabPane>
            <Tabs.TabPane key="2" tab="Article archivés">
              <DataTable
                customStyles={customStyles}
                columns={columns}
                data={articlesArchivated}
                pagination
                selectableRows
                noHeader
                striped
                selectableRowsHighlight
                fixedHeader
                onSelectedRowsChange={(e) => onSelectRow(e)}
                persistTableHead
                noDataComponent={<span>Pas d'articles trouvés</span>}
                contextMessage={{
                  singular: "élément",
                  plural: "éléments",
                  message: "séléctionné(s)",
                }}
                conditionalRowStyles={conditionalRowStyles}
              />
            </Tabs.TabPane>
          </Tabs>
        </Col>
      </Row>
      {fusionVisible && (
        <ArticleFusion
          visible={fusionVisible}
          setFusionVisible={() => setFusionVisible(false)}
        ></ArticleFusion>
      )}
      <ArticleModal
        saveArticle={saveArticle}
        details={articleDetails}
        createModalVisible={createModalVisible}
        closeCreateModal={exitCreateModal}
      />

      <Modal
        className="smtv-modal modal-large"
        visible={tecdocModalVisible}
        maskClosable={false}
        onCancel={exitModalTecdoc}
        footer={[
          <Button key="back" onClick={exitModalTecdoc}>
            Cancel
          </Button>,
        ]}
      >
        <Tecdoc
          reference=""
          displayTitle={false}
          addFromTecdoc={addFromTecdoc}
        />
      </Modal>
      <ArticleStat visible={false} />

      <ArticleDetail
        setDetailVisible={setDetailVisible}
        article={articleDisplay}
        visible={detailVisble}
      />
      {null != articleHistory && (
        <ArticleHistory
          setArticleHistory={() => setArticleHistory(null)}
          article={articleHistory}
          visible={articleHistory != null}
        />
      )}
      {tecdocLiaison && (
        <Modal
          className="smtv-modal modal-large"
          visible={tecdocLiaison}
          maskClosable={false}
          title={article.s__secondTitle + " " + article.s__reference}
          onCancel={(e) => setTecdocLiaison(false)}
          footer={[
            <Button key="back" onClick={(e) => setTecdocLiaison(false)}>
              Fermer
            </Button>,
          ]}
        >
          <TecdocLiaison
            selectedArticle={article}
            setTecdocLiaison={() => afterBind(false)}
          />
        </Modal>
      )}
      {transfertModal && (
        <StockTransfert
          close={() => {
            setTransfertModal(false);
            toSearch();
          }}
          article={articleDisplay}
          emplacements={emplacements}
        />
      )}
      <AdvancedSearchModal
        model="Article"
        visible={searchModalVisible}
        onClose={() => setSearchModalVisible(false)}
      />
      <Modal
        title="Choix d'impression"
        visible={printChoiceVisible}
        onCancel={() => setPrintChoiceVisible(false)}
        footer={null}
      >
        <Button
          type="primary"
          onClick={() => executePrint("prix")}
          style={{ marginRight: "1vh" }}
        >
          Prix
        </Button>
        <Button
          type="default"
          onClick={() => executePrint("inventaire")}
        >
          Inventaire
        </Button>
      </Modal>
    </div>
  );
};

export default Articles;
